const OverallValueCard = ({
  title,
  subTitle,
  value,
  isPositiveValue,
  badgeValue,
}: PropsType) => {
  return (
    <div className="flex flex-col col-span-full sm:col-span-6 xl:col-span-4 bg-white shadow-lg rounded-sm border border-slate-200">
      <div className="px-5 py-5">
        <h2 className="text-lg font-semibold text-slate-800  mb-2">{title}</h2>
        {subTitle && (
          <div className="text-xs font-semibold text-slate-400 uppercase mb-1">
            {subTitle}
          </div>
        )}
        <div className="flex items-start">
          <div
            className={`text-3xl font-bold mr-2 ${
              isPositiveValue === true
                ? 'text-green-500'
                : isPositiveValue === false
                ? 'text-red-500'
                : 'text-slate-500 '
            }`}
          >
            {value}
          </div>
          {badgeValue && (
            <div
              className={`text-sm font-semibold text-white px-1.5 rounded-full ${
                badgeValue >= 0 ? 'bg-emerald-500' : 'bg-amber-500'
              }`}
            >
              {badgeValue.toString() + '%'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

type PropsType = {
  title: string;
  subTitle?: string;
  value: string;
  isPositiveValue?: boolean;
  badgeValue?: number;
};

export default OverallValueCard;
